  <template>
  <v-card-text style="padding-top: 0">
    <v-layout column>
      <slot></slot>
      <v-layout v-show="expandableInt || printable" fill-height style="margin: -8px">
        <v-layout ma-0 v-show="printable" align-center justify-start>
        <v-print-btn :actions="printActions" :primary="primary"></v-print-btn>
        </v-layout>
        <v-layout ma-0 v-show="expandableInt" align-center justify-end>
        <span :class="textClass" @click="$emit('click')">{{caption}}</span>
        <v-btn style="margin-left: 0;" icon small @click.stop="$emit('click')"><v-icon :class="textClass">{{value ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon></v-btn>
        </v-layout>
      </v-layout>
    </v-layout>
  </v-card-text>
</template>

<script>
  import vPrintBtn from '../common/PrintBtn'
  export default {
    name: 'v-panel-text',
    components: {vPrintBtn},
    data: () => ({
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      expandable: {
        type: Boolean,
        default: true
      },
      printActions: {
        type: Array,
        default () {
          return []
        }
      },
      caption: {
        type: String,
        default: ''
      },
      primary: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      expandableInt () {
        return this.expandable
      },
      printable () {
        return this.printActions && (this.printActions.length > 0)
      },
      textClass () {
        return this.primary ? 'primary--text' : ''
      }
    }
  }
</script>




// WEBPACK FOOTER //
// PanelText.vue?4d2b53ce